import { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

type Props = {
  children?: ReactNode;
};

export default function Layout({ children }: Props) {
  return (
    <section>
    <Flex
      // flexDirection="column"
      // alignItems="center"
      // justifyContent="center"
      // h="100vh"
      width="100%"
      margin="auto"
      bg="white.800"
      display="block"
    >
      {children}
    </Flex>
    </section>
    
  );
}

